module.exports = __webpack_public_path__ + "img/9788937442087.470c6474.jpg";